import '~/js/modules/stickyNav';

import '~/js/views/resorts/includes/scroll-below';
// import '~/js/modules/countdown';
// import ResortSpecialOffers from '~/js/views/resorts/components/ResortSpecialOffers';

// const specialOffers = document.querySelector('#resort-special-offers');
// const offerList = [...sandals_app.page.offers];

// ReactDOM.render(<ResortSpecialOffers offerList={offerList} cdnURL={sandals_app.page.cdnURL} />, specialOffers);
